import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_a989b916";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_a989b916" };
/** script content **/
require("./picker-modal.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findexa989b916%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fpicker-modal%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_a989b916"],
    ctorType: "component",
    outputPath: "components/indexa989b916/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-picker-modal-base': getComponent(require("./picker-modal-base.mpx?isComponent&outputPath=components%2Fpicker-modal-base6c849b9a%2Findex")), 'cube-picker': getComponent(require("../picker/index.mpx?isComponent&outputPath=components%2Findex3b508115%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
